module.exports = __webpack_public_path__ + "static/media/vr-coding-ted-talk.e7c116d6.jpg";